"use strict";
/**
 * Geocoding utility for converting address text to coordinates
 * Uses Google Geocoding API via LetsTrade proxy
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCoordinates = exports.geocodeAddress = void 0;
/**
 * Convert a plain text address to coordinates using Google Geocoding API
 * @param address - The address string to geocode
 * @returns Coordinates object with lat/lng or null if geocoding fails
 */
function geocodeAddress(address) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var letsTradeUrl, url, response, data, location_1, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!address || address.trim().length === 0) {
                        return [2 /*return*/, null];
                    }
                    letsTradeUrl = process.env.LETS_TRADE_CLIENT_URL;
                    if (!letsTradeUrl) {
                        console.error("LETS_TRADE_CLIENT_URL not configured");
                        return [2 /*return*/, null];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    url = "".concat(letsTradeUrl, "/client/google/geocode?address=").concat(encodeURIComponent(address));
                    return [4 /*yield*/, fetch(url)];
                case 2:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _c.sent();
                    if (data.success && ((_b = (_a = data.content) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        location_1 = data.content.results[0].geometry.location;
                        return [2 /*return*/, {
                                lat: location_1.lat,
                                lng: location_1.lng,
                            }];
                    }
                    // Fallback: Try direct Google Geocoding API if LetsTrade fails
                    // Note: This requires GOOGLE_MAPS_API_KEY to be exposed to client
                    // which is generally not recommended for security reasons
                    console.warn("LetsTrade geocoding failed, address may not have coordinates");
                    return [2 /*return*/, null];
                case 4:
                    error_1 = _c.sent();
                    console.error("Geocoding failed:", error_1);
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.geocodeAddress = geocodeAddress;
/**
 * Parse coordinates that may be strings or numbers
 * @param lat - Latitude value (string or number)
 * @param lng - Longitude value (string or number)
 * @returns Parsed coordinates or null if invalid
 */
function parseCoordinates(lat, lng) {
    if (lat == null || lng == null) {
        return null;
    }
    var parsedLat = typeof lat === "string" ? parseFloat(lat) : lat;
    var parsedLng = typeof lng === "string" ? parseFloat(lng) : lng;
    if (isNaN(parsedLat) || isNaN(parsedLng)) {
        return null;
    }
    return { lat: parsedLat, lng: parsedLng };
}
exports.parseCoordinates = parseCoordinates;
